module.exports = __webpack_public_path__ + "img/DemonDagger_dagger.d5da6587.png";